<template>
  <footer class="py-3 footer" :class="{ 'px-4': isReporting }">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="mb-4 col-12 mb-lg-0">
          <div class="text-sm text-center copyright text-muted">
            ©
            {{ new Date().getFullYear() }} Aderize Inc.
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "app-footer",
  computed: {
    isReporting() {
      const path = this.$route.path || '';
      return path.startsWith('/share') || /\/reporting(\/|$)/.test(path);
    }
  }
};
</script>
